import React from "react";
import "./Hero.css";
import { useTranslation } from "../hooks/useTranslation";
import heroImg from "../beach.png"; // Using an existing image

const Hero = () => {
  const { t } = useTranslation();

  return (
    <section className="hero-section">
      <div className="hero-overlay"></div>
      <img src={heroImg} alt="Sri Lanka Hero" className="hero-bg-img" />
      
      <div className="container hero-container">
        <div className="hero-content animate-fadeIn">
          <span className="hero-badge">{t.welcomeTitle || "Welcome to Paradise"}</span>
          <h1 className="hero-title">
            Discover the <span className="highlight">Magic</span> of Sri Lanka
          </h1>
          <p className="hero-subtitle">
            {t.welcomeSubtitle || "Embark on an unforgettable journey through pristine beaches, lush mountains, and ancient heritage."}
          </p>
          <div className="hero-actions">
            <button className="primary-btn" onClick={() => window.scrollTo({ top: 800, behavior: 'smooth' })}>
              {t.exploreButton || "Explore Tours"}
            </button>
            <button className="secondary-btn">
              {t.learnMoreButton || "Learn More"}
            </button>
          </div>
        </div>
        
        <div className="hero-stats animate-fadeIn">
          <div className="stat-item">
            <span className="stat-number">10k+</span>
            <span className="stat-label">Happy Travelers</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">15+</span>
            <span className="stat-label">Destinations</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">24/7</span>
            <span className="stat-label">Expert Support</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
